"use client";
import {
  useGroup
} from "./ZPO4YZYE.js";
import {
  createElement,
  createHook,
  forwardRef
} from "./HKOOKEDE.js";
import {
  __objRest
} from "./3YLGPPWQ.js";

// src/composite/composite-group.tsx
var TagName = "div";
var useCompositeGroup = createHook(
  function useCompositeGroup2(_a) {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    props = useGroup(props);
    return props;
  }
);
var CompositeGroup = forwardRef(function CompositeGroup2(props) {
  const htmlProps = useCompositeGroup(props);
  return createElement(TagName, htmlProps);
});

export {
  useCompositeGroup,
  CompositeGroup
};
